'use client';

import clsx from 'clsx';
import { createContext, PropsWithChildren, useContext, useState } from 'react';

import styles from './Collapsable.module.css';

interface Context {
  isOpen: boolean;
  toggle: () => void;
}

const CollapsableContext = createContext<Context>({} as Context);

export const CollapsableTrigger = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  const { toggle, isOpen } = useContext(CollapsableContext);

  return (
    <button
      className={clsx(styles.trigger, className)}
      data-open={isOpen}
      onClick={toggle}
    >
      {children}
    </button>
  );
};

export const CollapsableContent = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  const { isOpen } = useContext(CollapsableContext);

  return (
    <div className={clsx(styles.content, className)} data-open={isOpen}>
      <div className={styles.contentInner}>{children}</div>
    </div>
  );
};

export const Collapsable = ({
  children,
  className,
  defaultOpen,
}: PropsWithChildren<{ className?: string; defaultOpen?: boolean }>) => {
  const [isOpen, setIsOpen] = useState(!!defaultOpen);

  return (
    <CollapsableContext.Provider
      value={{ isOpen, toggle: () => setIsOpen((prev) => !prev) }}
    >
      <div className={clsx(styles.root, className)} data-open={isOpen}>
        {children}
      </div>
    </CollapsableContext.Provider>
  );
};
